module.exports = __webpack_public_path__ + "static/media/feature-compare.798050c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feature-compare.png
// module id = 175
// module chunks = 0